import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as VideoCameraIconSvg } from '../../images/icon-video-camera.svg';
import styles from './RejoinCallFloatingButton.module.css';

type RejoinCallFloatingDataProps = {
  joinCall: (_: unknown) => void;
};

export default function RejoinCallFloatingButton({ joinCall }: RejoinCallFloatingDataProps) {
  return (
    <button className={styles.container} onClick={joinCall}>
      <div className={styles.videoIconContainer}>
        <VideoCameraIconSvg />
      </div>
      <div className={styles.textContainer}>
        <FormattedMessage id={'virtualWaitingRoom.call.rejoinCallFloatingButtonText'} />
      </div>
    </button>
  );
}
